import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../../app/authorization.service';

@Component({
    selector: 'app-opc',
    templateUrl: './opc.component.html'
})
export class OPCComponent implements OnInit {

    isToken = false;
    constructor(public authorizationService: AuthorizationService) {

    }
    ngOnInit() {
        this.authorizationService._tokenResponses.subscribe(res => {
            if (res) {
                this.isToken = true;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/opc.component.ts